import { FunctionComponent, ReactNode } from "react";
import { cn } from "../../utils/cn";

export interface ModalFooterProps {
  className?: string;
  children: ReactNode;
  "data-testid"?: string;
}

/**
 *
 */
export const ModalFooter: FunctionComponent<ModalFooterProps> = ({
  className,
  children,
  "data-testid": dataTestId,
}) => {
  const css = cn(className, "p-4 border-t");
  const testId = dataTestId || "modal-footer";
  return (
    <div className={css} data-testid={testId}>
      {children}
    </div>
  );
};

export default ModalFooter;
